import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { dateDistance, dateYMDE } from '@/utilities/dateUtils';

export function TachographDiagramDateTitle({ from, to }: { from: Date; to: Date }) {
  const { i18n, t } = useTranslation();
  const isSameDay =
    from.getFullYear() === to.getFullYear() && from.getMonth() === to.getMonth() && from.getDate() == to.getDate();
  return (
    <Stack
      direction="row"
      spacing={2}
      bgcolor="grey.300"
      py={0.5}
      px={1}
      borderRadius={4}
      width="fit-content"
      data-qa-element-id="diagram_date_title"
    >
      {isSameDay ? (
        <Typography data-qa-element_id="single_date_label">{dateYMDE(to, i18n.language, t)}</Typography>
      ) : (
        <>
          <Typography data-qa-element-id="from_to_date_label">
            {dateYMDE(to, i18n.language, t)} - {dateYMDE(from, i18n.language, t)}
          </Typography>
          <Typography color="info" fontWeight="bold" data-qa-element-id="from_to_date_fiff_label">
            {dateDistance(from, to, i18n.language)}
          </Typography>
        </>
      )}
    </Stack>
  );
}
